/**
 * Phone message types for SMS and WhatsApp
 */
export enum PhoneMessageTypeEnum {
  SMS = "sms",
  WHATSAPP = "whatsapp"
}
